export default function changeUserPasswordReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_USER_PASSWORD_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_USER_PASSWORD_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_USER_PASSWORD_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}